import { render, staticRenderFns } from "./SubmitMessage.vue?vue&type=template&id=62b859de&scoped=true"
import script from "./SubmitMessage.vue?vue&type=script&lang=js"
export * from "./SubmitMessage.vue?vue&type=script&lang=js"
import style0 from "./SubmitMessage.vue?vue&type=style&index=0&id=62b859de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b859de",
  null
  
)

export default component.exports